<template>
  <div>
    <a-modal v-model="visible" :width="1024" title="任务数据明细" @cancel="onClose">
      <a-table :scroll="{ x: 1200 }" :columns="columns" :data-source="tableData" row-key="id" size="small">
        <span slot="taskId" slot-scope="text, record" style="cursor: pointer" @click="onCopy(`TS-${record.id}`)">
          <div v-if="record.delivery_alone == 1" class="corner" />
          {{ `TS-${record.id}` }}
        </span>
        <span slot="status" slot-scope="text, record">
          <a-tag v-if="taskStatus[record.status]" :color="taskStatus[record.status].color">{{ taskStatus[record.status].label }}</a-tag>
        </span>
        <span slot="priority" slot-scope="text, record">
          <a-badge v-if="taskPrioritys[record.priority]" :color="taskPrioritys[record.priority].color" :text="taskPrioritys[record.priority].label" />
          <span v-else>--</span>
        </span>
        <span slot="point" slot-scope="text, record">
          {{ record.point }}<span class="task-points">({{ record.point * 2 }}人时)</span>
        </span>
        <span slot="taskName" slot-scope="text, record">
          <a-tooltip title="任务" style="margin-right: 4px">
            <svg t="1662379348404" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1217" width="16" height="16">
              <path d="M728.4736 936.3456H393.5744c-130.6112 0-236.4416-105.8816-236.4416-236.4416V266.6496c0-87.6032 71.0144-158.6176 158.6176-158.6176h334.8992c130.6112 0 236.4416 105.8816 236.4416 236.4416v433.2544c0 87.6032-71.0144 158.6176-158.6176 158.6176z" fill="#6FCBF6" p-id="1218" />
              <path d="M640.8192 246.4256H298.8544c-78.2848 0-141.7216 63.4368-141.7216 141.7216v301.9264c0 135.9872 110.1824 246.2208 246.1696 246.2208h325.1712c87.6032 0 158.5664-71.0144 158.6176-158.5664V492.6976c0-136.0384-110.2336-246.272-246.272-246.272z" fill="#68BEF3" p-id="1219" />
              <path d="M640.8192 384.8192H298.8544c-78.2848 0-141.7216 63.4368-141.7216 141.7216v163.5328c0 135.9872 110.1824 246.2208 246.1696 246.2208h325.1712c87.6032 0 158.5664-71.0144 158.6176-158.5664v-146.688c0-135.9872-110.2336-246.2208-246.272-246.2208z" fill="#5CAAF0" p-id="1220" />
              <path d="M676.5056 361.9328h-308.736c-22.0672 0-39.9872-16.4352-39.9872-36.7616 0-20.2752 17.92-36.7616 39.9872-36.7616h308.736c22.0672 0 39.9872 16.4352 39.9872 36.7616 0 20.3264-17.92 36.7616-39.9872 36.7616zM577.3824 555.4688H367.7184c-22.0672 0-39.9872-16.4352-39.9872-36.7616s17.92-36.7616 39.9872-36.7616h209.664c22.0672 0 39.9872 16.4352 39.9872 36.7616s-17.8688 36.7616-39.9872 36.7616z" fill="#FFFFFF" p-id="1223" />
            </svg>
          </a-tooltip>
          <a-tooltip placement="top" :title="record.name">
            <a class="task-edit_name" :href="link" target="_blank">{{ record.name }}</a>
          </a-tooltip>
        </span>
      </a-table>
    </a-modal>
  </div>
</template>
<script>
import { taskStatus, taskPrioritys } from '@/utils/dictionary';
import { taskPointDetail } from '@/api/data/task';
const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 80,
    scopedSlots: { customRender: 'taskId' }
  },
  {
    title: '任务名称',
    dataIndex: 'name',
    key: 'name',
    width: 300,
    ellipsis: true,
    scopedSlots: { customRender: 'taskName' }
  },
  {
    title: '处理人',
    dataIndex: 'handlers',
    key: 'handlers',
    width: 120,
    ellipsis: true,
    customRender: text => {
      return text ? text.map(user => user.nickname).join('; ') : '--';
    }
  },
  {
    title: '优先级',
    dataIndex: 'priority',
    key: 'priority',
    width: 100,
    scopedSlots: { customRender: 'priority' }
  },
  {
    title: '状态',
    dataIndex: 'status',
    key: 'status',
    width: 100,
    scopedSlots: { customRender: 'status' }
  },
  {
    title: 'TaskPoint',
    dataIndex: 'point',
    key: 'point',
    width: 108,
    scopedSlots: { customRender: 'point' }
  },
  {
    title: '计划开始时间',
    dataIndex: 'pre_start_time',
    key: 'pre_start_time',
    width: 110,
    customRender: text => {
      return text || '--';
    }
  },
  {
    title: '计划结束时间',
    dataIndex: 'pre_end_time',
    key: 'pre_end_time',
    width: 110,
    customRender: text => {
      return text || '--';
    }
  },
  {
    title: '完成时间',
    dataIndex: 'completed_time',
    key: 'completed_time',
    width: 168,
    customRender: text => {
      return text || '--';
    }
  },
  {
    title: '创建时间',
    dataIndex: 'created_time',
    key: 'created_time',
    width: 168
  },
  {
    title: '更新时间',
    dataIndex: 'updated_time',
    key: 'updated_time',
    width: 168
  }
];
export default {
  props: {
    display: {
      type: Boolean,
      default: false
    },
    filterFrom: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      columns,
      taskStatus,
      taskPrioritys,
      visible: false,
      loading: true,
      tableData: []
    };
  },
  computed: {
    link() {
      return () => {
        return;
      };
    }
  },
  watch: {
    display() {
      this.visible = this.display;
      if (this.visible === true) {
        this.getTaskPointDetail();
      }
    }
  },
  methods: {
    getTaskPointDetail() {
      this.loading = true;
      taskPointDetail(this.filterFrom)
        .then(res => {
          this.tableData = res.data.items;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onClose() {
      this.$emit('close');
    }
  }
};
</script>
